export enum CarrierRateChangeSetStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}
